import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';

export default function MultiCheck({ label, items, form, formKey, prefix, toggleIn, t }) {
	return (
		<div>
			<Label className="block mb-2">{ label }</Label>
			<div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
				{ items.map((s) => (
					<label key={ s } className="flex items-center gap-2 cursor-pointer text-sm text-[#3a3a3a] select-none">
						<Checkbox checked={ form[formKey].includes(s) } onCheckedChange={ () => toggleIn(formKey, s) }
											data-testid={ `trainer-${ formKey }-${ s }` }/>
						{ t(`${ prefix }.${ s }`) }
					</label>
				)) }
			</div>
		</div>
	);
};